import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface MergeDisclaimerProps {
  showUnifiedContact?: boolean;
  showListingsNote?: boolean;
  showPropertyTracksNote?: boolean;
}

const MergeDisclaimer: React.FC<MergeDisclaimerProps> = ({
  showUnifiedContact = false,
  showListingsNote = false,
  showPropertyTracksNote = false,
}) => {
  if (!showUnifiedContact && !showListingsNote && !showPropertyTracksNote)
    return null;

  const messages: string[] = [];

  if (showUnifiedContact) {
    messages.push(
      "Contact information from the selected leads will be merged into a single customer record."
    );
  }

  if (showListingsNote) {
    messages.push(
      "listings from the child lead will be transferred to a parent lead with type allows accepting listings"
    );
  }

  if (showPropertyTracksNote) {
    messages.push(
      "Property tracks from the child lead will be moved to the parent lead after merging."
    );
  }

  return (
    <Box
      sx={{ mt: "24px", display: "flex", flexDirection: "column", gap: "8px" }}
    >
      {messages.map((message, idx) => (
        <Typography
          key={idx}
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
            color: "#F79008",
          }}
        >
          {message}
        </Typography>
      ))}
    </Box>
  );
};

export default MergeDisclaimer;
